import React, { useEffect } from "react";

const Unauthorised = () => {


  return <div>Unauthorised</div>
};
export default Unauthorised
